import React from 'react';
import { Route, Routes } from 'react-router';
import NotFound from '@atoms/Images/NotFound';
import GenericLoader from '@molecules/Loaders/GenericLoader';
import Login from '@pages/Account/Login';
import RootIndex from '@pages/Root/RootIndex';
import RequireAuth from './RequireAuth';
import SPGQSpecialRoutes from './SPGQSpecialRoutes';

const LazyAdminRoot = React.lazy(() => import('./AdminRoutes'));
const LazyReleaseNotes = React.lazy(() => import('@pages/ReleaseNotes'));
const LazyEnvironmentInfo = React.lazy(() => import('@pages/EnvironmentInfo'));
const LazySimpleLayout = React.lazy(() => import('@templates/SimpleLayout'));
const LazyCarteMembreRoot = React.lazy(() => import('./CarteMembreRoutes'));
const LazySysAdminRoot = React.lazy(() => import('./SystemAdminRoutes'));
const LazyFormulaireRoutes = React.lazy(() => import('./FormulaireRoutes'));
const LazyVoteRoutes = React.lazy(() => import('./VoteRoutes'));
const LazyInfoRoutes = React.lazy(() => import('./InfoRoutes'));

function AdminRoutes() {
  return (
    <React.Suspense fallback={<GenericLoader />}>
      <RequireAuth permittedRoles={['SystemAdmin', 'ClientAdmin']}>
        <LazyAdminRoot />
      </RequireAuth>
    </React.Suspense>
  );
}

function FormulaireRoutes() {
  return (
    <React.Suspense fallback={<GenericLoader />}>
      <LazyFormulaireRoutes />
    </React.Suspense>
  );
}

function SystemAdminRoutes() {
  return (
    <React.Suspense fallback={<GenericLoader />}>
      <RequireAuth permittedRoles={['SystemAdmin']}>
        <LazySysAdminRoot />
      </RequireAuth>
    </React.Suspense>
  );
}


function CarteMembreRoutes() {
  return (
    <React.Suspense fallback={<GenericLoader />}>
      <LazyCarteMembreRoot />
    </React.Suspense>
  );
}

function VoteRoutes() {
  return (
    <React.Suspense fallback={<GenericLoader />}>
      <LazyVoteRoutes />
    </React.Suspense>
  );
}

function InfoRoutes() {
  return (
    <React.Suspense fallback={<GenericLoader />}>
      <LazyInfoRoutes />
    </React.Suspense>
  );
}

function RootRoutes() {
  return (
    <Routes>
      {/* Hack temporaire pour le SPGQ pour que les routes existantes fonctionnent */}
      <Route path="consentement/:idEmploye" element={<SPGQSpecialRoutes formulaire="consentement" />} />
      <Route path="signature/:idEmploye" element={<SPGQSpecialRoutes formulaire="signature" />} />
      <Route path="signature/avec-consentement/:idEmploye"
             element={<SPGQSpecialRoutes formulaire="signature-avec-consentement" />} />
      {/* Fin du hack */}

      <Route index element={<RootIndex />} />
      <Route path="admin/*" element={<AdminRoutes />} />
      <Route path="sysadmin/*" element={<SystemAdminRoutes />} />
      <Route path="cartemembre/*" element={<CarteMembreRoutes />} />
      <Route path="formulaire/*" element={<FormulaireRoutes />} />
      <Route path="votez/*" element={<VoteRoutes />} />
      <Route path="info/*" element={<InfoRoutes />} />
      <Route path="login" element={<Login />} />

      {/* Simple layout routes */}
      <Route element={<React.Suspense fallback={<GenericLoader />}><LazySimpleLayout /></React.Suspense>}>
        <Route path="release-notes" element={<React.Suspense fallback={<GenericLoader />}><LazyReleaseNotes /></React.Suspense>} />
        <Route path="environment-info" element={<React.Suspense fallback={<GenericLoader />}><LazyEnvironmentInfo /></React.Suspense>} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default RootRoutes;
